module.exports = __webpack_public_path__ + "static/media/hidden-objects.fa465f00.svg";